import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import {
    ContentProvider,
    Company,
    ExternalContentProvider,
} from '@lighty';
import {
    EmitterService,
    ErrorStreamService,
    StorageService,
    TranslateService
} from '@services';
import { CookieService } from 'ngx-cookie-service';
import { DataHelper, DownloadHelper, UrlHelper } from '@helpers';
import { Subscription, Observable, Subject } from 'rxjs';
import { skip, tap, finalize, take } from 'rxjs/operators';
import moment from "moment";
import { environment } from '@env/environment';
import { CommonToastService } from '@common2/services/toast.service';

@Component({
    selector: 'msc-learn-detail-external-content-presentation',
    templateUrl: './presentation.component.html',
    styleUrls: ['./presentation.component.scss'],
})
export class LearnDetailExternalContentPresentationComponent
    implements OnInit, AfterViewInit, OnDestroy {

    public company: Company;
    public externalContent: any;
    public externalContentType: string;
    public externalContentApiCallCopy: () => Observable<any>;
    private repeat$: Subject<void> = new Subject<void>();
    public callToAction: string;
    public dropdowns: any;
    public card: any;
    public contentSections;
    public loading: any = {
        bookboon: false,
        trainingexpress: false,
        hasCard: false,
        sections: false,
    };
    // changeLearnLaterContent: Subscription;
    public ratingInfo: any;
    public saved: boolean = false;
    public subscribed: boolean = false;
    public contentProgress: number = 0;

    constructor(
        private route: ActivatedRoute,
        private toastService: CommonToastService,
        private contentProvider: ContentProvider,
        private storageService: StorageService,
        private router: Router,
        private externalContentProvider: ExternalContentProvider,
        private translateService: TranslateService,
        private errorStreamService: ErrorStreamService,
        private emitterService: EmitterService,
        private cookieService: CookieService,
        private location: Location,
    ) { }

    goBack(): void {
        this.location.back();
    }
    /*
        ngOnInit(): void {
            this.company = this.storageService.get('company');
            console.log(this.router)
            this.externalContent = this.route.parent.snapshot.data.externalContent;
                    console.log('external content', this.externalContent);
            this.saved = this.externalContent.saved;
            this.subscribed = this.externalContent.subscribed;
            
    
            this.externalContentApiCallCopy =
                this.route.parent.snapshot?.data?.externalContentApiCallCopy;
    
            this.dropdowns = {
                card: false,
                request: false,
            };
    
            this.route.parent.params.subscribe((params) => {
                this.externalContentType = params.externalContentContext;
                this.defineCallToActionText();
    
                if (
                    this.externalContent.subscribed &&
                    this.externalContentType === 'bookboon' &&
                    this.externalContent.type === 'audio'
                ) {
                    this.getSections();
                }
            });
            this.getRatingInfo();
        }*/

    ngOnInit(): void {
        this.company = this.storageService.get('company');
        this.dropdowns = {
            card: false,
            request: false,
        };

        // Suscribirse a los datos del resolver
        this.route.parent.data.subscribe(data => {
            this.externalContent = data.externalContent;
            console.log('external content', this.externalContent);

            this.saved = this.externalContent.saved;
            this.subscribed = this.externalContent.subscribed;
            this.externalContentApiCallCopy = data.externalContentApiCallCopy;

            // Si ya tienes el parámetro cargado, actualiza el tipo
            const externalContentType = this.route.parent.snapshot.params.externalContentContext;
            if (externalContentType) {
                this.externalContentType = externalContentType;
                this.defineCallToActionText();

                if (
                    this.externalContent.subscribed &&
                    this.externalContentType === 'bookboon' &&
                    this.externalContent.type === 'audio'
                ) {
                    this.getSections();
                }
            }

            this.getRatingInfo();
            const navState = history.state;
            if (typeof navState?.progress === 'number') {
                this.contentProgress = navState.progress;
            } else {
                this.getProgress();
            }

            //saved
            this.saved = !!this.externalContent.saved;
        });

        // En caso de que cambien los parámetros de la ruta
        this.route.parent.params.subscribe(params => {
            this.externalContentType = params.externalContentContext;
            this.defineCallToActionText();
        });
    }

    ngAfterViewInit(): void {
        this.route.queryParams.subscribe((params) => {
            const timeOut = setTimeout(() => {
                if (params.direct_play) {
                    this.subscribeOrAction();
                } else if (params.action) {
                    this.doAction();
                }

                clearTimeout(timeOut);
            }, 1000);
        });
    }

    get isButtonLoading() {
        return this.loading.bookboon || this.loading.trainingexpress;
    }

    private defineCallToActionText(): void {
        let translationString;
        if (this.externalContentType == 'bookboon') {
            if (this.externalContent.type === 'audio') {
                translationString = 'words.subscribe';
            } else {
                translationString = 'words.download';
            }
        } else {
            translationString = this.externalContent.subscribed
                ? 'words.access-content'
                : 'words.subscribe';
        }
        this.callToAction = this.translateService.instant(translationString);
    }

    private download(): void {
        this.loading.bookboon = true;
        this.errorStreamService.locked();
        this.toastService.onSuccess(this.translateService.instant('toast.downloading.soon'));
        this.externalContentProvider
            .download(this.externalContent.id)
            .subscribe(
                (data) => {
                    DownloadHelper.downloadBlob(
                        data,
                        this.externalContent.title
                    );
                    this.toastService.onSuccess(this.translateService.instant('toast.bookboon.download-success'));
                    this.emitterService.set('player-light.open', {
                        type: 'external',
                        content: this.externalContent,
                        more: this.externalContent,
                        progressEnabled: this.externalContent.provider
                            ? this.externalContent.provider.progressEnabled
                            : true,
                    });
                },
                () => {
                    this.errorStreamService.unlocked();
                    this.toastService.onError(this.translateService.instant('toast.error-occurred'));
                },
                () => {
                    this.loading.bookboon = false;
                }
            );
    }

    private doAction(): void {
        switch (this.externalContentType) {
            case 'bookboon':
                if (this.externalContent.type === 'audio') {
                    this.getSections();
                } else {
                    this.download();
                }
                break;
            case 'external_video':
                this.openExternalUrl('video');
                break;
            default:
                // only if udemy content and custom URL
                if (
                    (this.externalContent?.url?.includes('udemy.com')
                        || this.externalContent?.url?.includes('linkedin.com')
                        || this.externalContent?.url?.includes('contentraven.com')
                        || this.externalContent?.url?.includes('learninghubz.com')
                        || this.externalContent?.url?.includes('coursera.org')
                        || this.externalContent?.url?.includes('platzi.com')
                        || this.externalContent?.url?.includes('learnlight.com')
                    )
                    && `${UrlHelper.getHost()}/` !== environment.envVar.APP_URL.replace('https://', '').replace('http://', '')) {
                    this.externalContentProvider.storeUserToken(this.externalContent.url)
                        .subscribe((token: string) => {
                            UrlHelper.navigate(`${environment.envVar.AUTHORIZATION_SERVER_URL}/authenticated-redirect?token=${token}`);
                        })
                } else {
                    this.openExternalUrl('external');
                }

                break;
        }

        this.defineCallToActionText();
        this.emitterService.set('refreshSubscription', {
            subscribed: this.externalContent.subscribed,
        });
    }

    private getSections(): void {
        this.loading.sections = true;
        this.externalContentProvider
            .getExternalContentSections(this.externalContent.id)
            .subscribe(
                (data) => {
                    this.contentSections = data.sections;
                    this.loading.sections = false;
                },
                () => {
                    this.loading.sections = false;
                }
            );
    }

    private getNewUrl() {
        return this.externalContentProvider
            .generateUrl({
                company_id: this.company.id,
                provider_id: this.externalContent.provider.id,
                context_id: this.externalContent.id,
                context_type: 'external_content',
            })
            .pipe(
                take(1),
                tap(({ url }) => {
                    this.externalContent.url = url;
                    UrlHelper.navigate(url || this.externalContent.url);
                }),
                finalize(() => {
                    this.loading.trainingexpress = false;
                })
            );
    }

    public openExternalUrl(type, url?) {
        if (this.externalContent.requireUrlGeneration) {
            this.loading.trainingexpress = true;
            this.getNewUrl().subscribe();
        } else {

            UrlHelper.navigate(url || this.externalContent.url);

            this.emitterService.set('player-light.open', {
                type: type,
                content: { ...this.externalContent, type: type },
                more: { ...this.externalContent, type: type },
                progressEnabled: this.externalContent.provider
                    ? this.externalContent.provider.progressEnabled
                    : true,
            });
        }
    }

    private subscribeAndDoAction(): void {
        if (this.externalContentType === 'external_video') {
            this.externalContentProvider
                .subscribeVideo(this.externalContent.id, this.externalContent)
                .subscribe({
                    next: (data) => {
                        if (data) {
                            this.externalContent.subscribed = true;
                        }
                        this.doAction();
                    },
                    error: (failure) => this.handleSubscribeError(failure),
                });
        } else {
            this.externalContentProvider
                .subscribeContent(this.externalContent.id)
                .subscribe({
                    next: (data) => {
                        if (data) {
                            this.externalContent.subscribed = true;
                        }
                        this.doAction();
                    },
                    error: (failure) => this.handleSubscribeError(failure),
                });
        }
    }

    private handleSubscribeError(failure: any): void {
        console.error('Error subscribing to external content:', failure);
        const translationKey = failure?.error?.translationKey;
        this.toastService.onError(
            this.translateService.instant(translationKey ? `toast.${translationKey}` : 'toast.error-occurred')
        );
    }

    addToSavedContents(): void {
        this.externalContent.saved = true;

        const params = {
            context: 'external_content',
            context_id: this.externalContent.id,
        };

        this.contentProvider.addSavedContent(params).subscribe(() => {
            this.toastService.onSuccess(this.translateService.instant('toast.learn-later.saved'));
        });
    }

    deleteSavedContent(): void {
        this.externalContent.saved = false;

        const params = {
            context: 'external_content',
            context_id: this.externalContent.id,
        };

        this.contentProvider.deleteSavedContent(params).subscribe(() => {
            this.toastService.onSuccess(this.translateService.instant('toast.learn-later.deleted'));
        });
    }

    subscribeOrAction(): void {
        this.externalContent.subscribed
            ? this.doAction()
            : this.subscribeAndDoAction();
    }

    colorType(): string {
        switch (this.externalContentType) {
            case 'bookboon':
                return 'orange';
            case 'resource':
                switch (this.externalContent.type) {
                    case 'course':
                        return 'purple';
                    case 'video':
                        return 'blue';
                    case 'article':
                        return 'orange';
                    case 'other':
                        return 'red';
                }
                break;
            default:
                return 'purple';
        }
    }

    openDropdowns(type: string): void {
        this.dropdowns[type] = !this.dropdowns[type];
    }

    changeComma(value: string): void {
        value = value.replace(',', '.');
    }

    stopPropagation(event: any): void {
        event.stopPropagation();
    }

    ngOnDestroy(): void {
        // this.changeLearnLaterContent.unsubscribe();
        this.repeat$.complete();
    }
    private readonly KNOWN_PROVIDERS = ['appcues','bookboon','cefora','cegos','coursera','edflex-blue','email-apside','freshchat','goodhabitz','gotowebinar','learncube','mymooc','openclassroom','trainingexpress','udemy','youtube','linkedin','aws','learninghubz','coursera-for-campus','boclips','netzun','onementor','coursera-career-academy','xertify','power_bi_dashboards','platzi','coursera-multi-programs'];

    public getProviderLogoUrl(): string | null {
        const content = this.externalContent;
        const provider = content?.provider;
        const rawLogo = this.company?.experience?.displayPicture || this.company?.picture;
        let url: string | null = null;

        if (content?.type === 'boclips') {
            url = 'https://static.myskillcamp.com/images/integrations/boclips.svg';
        } else if (provider?.key && this.KNOWN_PROVIDERS.includes(provider.key)) {
            url = `https://static.myskillcamp.com/images/integrations/${provider.key}.svg`;
        } else if (provider?.media?.pictureUrl) {
            if (this.company?.id === provider.responsibleId && provider.responsibleType === 'company') {
                url = rawLogo ? `${rawLogo}?size=256` : null;
            } else {
                url = `${provider.media.pictureUrl}?size=256`;
            }
        } else if (rawLogo) {
            url = `${rawLogo}?size=256`;
        }

        if (url && !environment.production && url.includes('api-upgraded.myskillcamp.com.deltabluecdn.com')) {
            url = url.replace('https://api-upgraded.myskillcamp.com.deltabluecdn.com', 'https://api.myskillcamp.com');
        }
        return url;
    }

    public convertSecondsToHoursMinutes(seconds: number): string {
        if (seconds < 0 || isNaN(seconds)) {
            return '0h0m';
        }

        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);

        return `${hours}h${minutes}m`;
    }

    public getProgress(): void {
        const params = { company_id: this.company.id, per_page: 200 };
        this.contentProvider
            .getContents(params)
            .pipe(take(1))
            .subscribe({
                next: ({ contents }) => {
                    const match = contents.find((c: any) => c.data?.id === this.externalContent.id);
                    this.contentProgress = match?.data?.progress ?? 0;
                },
                error: () => {
                    this.contentProgress = 0;
                }
            });
    }

    public getRatingInfo(): void {
        const params = {
            contentId: this.externalContent.id,
            contentType: this.externalContent.contentType,
        }
        this.contentProvider.getContentRating(this.company.id, params).pipe(take(1)).subscribe((data) => {
            this.ratingInfo = data;
        });
    }

    public handleRating(data: { rating: number; comment: string, isFirstTime: boolean }): void {
        const params = {
            contentId: this.externalContent.id,
            contentType: this.externalContent.contentType,
            rating: data.rating,
            comment: data.comment
        }
        console.log('rating params', params);
        if (this.ratingInfo.userRating === null) {
            this.contentProvider.rateContent(this.company.id, params).pipe(take(1)).subscribe((response) => {
                this.toastService.onSuccess(this.translateService.instant('toast.rating-success'));
                this.getRatingInfo();
            });
        } else {
            this.contentProvider.rateContentUpdate(this.company.id, params, this.ratingInfo.userRatingId).pipe(take(1)).subscribe((response) => {
                this.toastService.onSuccess(this.translateService.instant('toast.rating-update-success'));
                this.getRatingInfo();
            });
        }
    }

    public getStars(rating: number): number[] {
        return Array(rating).fill(0);
    }

    public clipboard(): void {
        if (this.company.customUrl) {
            if (this.company.customUrl.slice(-1) === '/') {
                DataHelper.clipboard(`${this.company.customUrl}${location.pathname.substring(1)}`);
            } else {
                DataHelper.clipboard(`${this.company.customUrl}${location.pathname}`);
            }
        } else {
            DataHelper.clipboard(location.href);
        }
        this.toastService.onSuccess(this.translateService.instant('toast.link-clipboard'));
    }


    public changeLearnLaterContent(): void {
        this.saved = !this.saved;
        let context = 'external_content';
        let context_id = this.externalContent.id;
        this.externalContent.saved = this.saved;


        let params = {
            context: context,
            context_id: context_id
        }

        if (this.saved) {
            this.contentProvider.addSavedContent(params).subscribe(() => {
                console.log('saving')
                this.toastService.onSuccess(this.translateService.instant('toast.learn-later.saved'));
            });
        } else {
            this.contentProvider.deleteSavedContent(params).subscribe(() => {
                console.log('deleting')
                this.toastService.onSuccess(this.translateService.instant('toast.learn-later.deleted'));
            });
        }
    }

    public deleteContent(data): void {
        this.externalContentProvider.unsubscribe(this.externalContent.id).subscribe(() => {
            this.router.navigate(['/learn', this.company.slug, 'contents']);
            this.toastService.onSuccess(this.translateService.instant('toast.unregister'));
        });
    }


}
